// external scripts
import $ from "jquery";
import debug from 'bows/dist/bows.min.js';

// example of ES2015 modules loading & tree shaking
import { emptyLinks } from "./base/_links";

import size from "./base/_size";
import isTouch from "./base/_isTouch";
import fitvid from "./base/_fitvid";
import keyboardFocus from "./base/_keyboardFocus";
import smoothScroll from "./base/_smoothScroll";
import share from "./base/_share";
import loadScripts from "./base/_loadScripts";
import tracking from "./base/_tracking";

// Site
import general from "./_general";
import accordions from "./_accordions";
import tabs from "./base/_tabs";
import slickSlider from "./_slick";
import mmenu from "./_mmenu";


const $window = $(window);
const $document = $(document);
const log = debug("site");

class Site {
	constructor() {
		document.addEventListener('DOMContentLoaded', () => this.ready());
		window.addEventListener('load', () => this.load());
	}

	ready() {
		$('html').removeClass('no-js').addClass('js');
		const log = debug("site:domReady");

		tracking.init();

		isTouch.init();
		keyboardFocus.init();
		smoothScroll.init();
		share.init();
		size.init();
		//picturefill();
		fitvid();
		general.init();

		if ($('.component--tab-content').length) {
			tabs.init();
		}

		log('document.DOMContentLoaded');
	}

	load() {
		const log = debug("site:windowLoad");
		log("window.onload");

		// example of ES2015 modules loading & tree shaking
		//emptyLinks();
	}

}

export default new Site;
